import React from 'react';
import { connect } from '../../redux/store';
import { compose, withProps } from 'recompose';
import { parse } from 'query-string';
import {
  ErrorMessage,
  Image,
  Utils,
  C,
  H,
  ReportSiteIssueWrapper,
} from '@kineticdata/bundle-common';
import { CoreForm } from '@kineticdata/react';
import { PageTitle } from '../shared/PageTitle';

const Layout = connect(state => ({
  reportForm: H.selectReportSiteIssueForm(state),
}))(({ form, content, reportForm }) => (
  <ReportSiteIssueWrapper form={form} reportForm={reportForm}>
    {content}
  </ReportSiteIssueWrapper>
));

const PageComponent = ({ kappSlug, pageSlug, values, portalPage, image }) => (
  <div className="page-container">
    {image && (
      <div className="page-image">
        <Image src={image} alt="" />
      </div>
    )}
    <div className="page-panel">
      {!!portalPage ? (
        <>
          <PageTitle
            parts={[(portalPage.name || pageSlug, 'Page')]}
            title={portalPage.name || pageSlug}
          />
          <div className="portal-page__wrapper">
            <CoreForm
              kapp={kappSlug}
              form={pageSlug}
              // unauthorized={handleUnauthorized}
              values={values}
              // public={!authenticated}
              layoutComponent={Layout}
            />
          </div>
        </>
      ) : (
        <>
          <PageTitle parts={[pageSlug, 'Page']} />
          <ErrorMessage message="Page not found" />
        </>
      )}
    </div>
  </div>
);

const valuesFromQueryParams = queryParams => {
  const params = parse(queryParams);
  return Object.entries(params).reduce((values, [key, value]) => {
    if (key.startsWith('values[')) {
      const vk = key.match(/values\[(.*?)\]/)[1];
      return { ...values, [vk]: value };
    }
    return values;
  }, {});
};

export const mapStateToProps = (state, { pageSlug }) => ({
  portalPage: state.app.portalPages.find(p => p.slug === pageSlug),
  values: valuesFromQueryParams(state.router.location.search),
  kappSlug: state.app.kappSlug,
  appLocation: state.app.location,
  authenticated: state.app.authenticated,
  authRoute: state.app.authRoute,
});

export const Page = compose(
  connect(mapStateToProps),
  withProps(props => ({
    image:
      props.portalPage &&
      Utils.getAttributeValue(
        props.portalPage,
        C.ATTR_IMAGE,
        Utils.getAttributeValue(
          props.portalPage.kapp || {},
          C.ATTRIBUTE_KAPP_DEFAULT_FORM_IMAGE,
        ),
      ),
  })),
)(PageComponent);
